export default {

  // return a Promise after insert script tag
  // Promise will resolve after script loaded
  insertScript: function(id, src) {

    let node;

    // if already have script tag with same id immediately reject
    if (document.getElementById(id)) {
      return Promise.reject('script already exists');
    }

    node = document.getElementsByTagName('script')[0];
    if (typeof node === 'undefined') {
      let head = document.getElementsByTagName('head'),
        script = document.createElement('script');
      head[0].appendChild(script);
      node = script;
    }

    return new Promise((resolve, reject) => {
      let js = document.createElement('script');
      js.id = id;
      js.async = true;
      js.defer = true;
      js.src = src;
      js.addEventListener('load', function () {
        resolve();
      });
      js.addEventListener('error', function (e) {
        reject(e);
      });
      node.parentNode.insertBefore(js, node);
    });
  }
};
